<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('menu.tag')"
    resource="acts_as_taggable_on/tags"
  >
    <router-link slot="action" v-if="abilityService.can('tags.create')" :to="{ name: 'acts_as_taggable_on/tags.new' }">
      <el-button type="primary">{{ $t('new') }}</el-button>
    </router-link>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { abilityService } from 'beans-admin-plugin';

@Component
export default class Tags extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}
  abilityService = abilityService

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'name_cont',
        label: this.$t('tag.name'),
        renderCell: {
          component: 'input',
        }
      },
    ]
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    return [
      {
        prop: 'id',
        label: this.$t('id'),
      },
      {
        prop: 'name',
        label: this.$t('tag.name'),
      },
      {
        prop: 'position',
        label: this.$t('tag.position'),
      },
      {
        prop: 'created_at',
        label: this.$t('createdAt'),
        renderCell: 'time',
      },
      {
        prop: 'updated_at',
        label: this.$t('updatedAt'),
        renderCell: 'time',
      },
    ]
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
      {
        prop: 'name',
        label: this.$t('tag.name'),
        renderCell: {
          component: 'input',
        }
      },
      {
        prop: 'position',
        label: this.$t('tag.position'),
        renderCell: {
          component: 'inputNumber',
          hint: this.$t('hints.positionColumn'),
        }
      },
    ]
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'acts_as_taggable_on/tags.edit', params: { id: row.id } },
          can: 'tags.destroy'
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'tags.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/acts_as_taggable_on/tags',
    name: 'acts_as_taggable_on/tags.index',
    component: Tags,
    props: {
      type: 'index',
    }
  },
  {
    path: '/acts_as_taggable_on/tags/new',
    name: 'acts_as_taggable_on/tags.new',
    component: Tags,
    props: {
      type: 'new',
    }
  },
  {
    path: '/acts_as_taggable_on/tags/:id',
    name: 'acts_as_taggable_on/tags.show',
    component: Tags,
    props: {
      type: 'show',
    }
  },
  {
    path: '/acts_as_taggable_on/tags/:id/edit',
    name: 'acts_as_taggable_on/tags.edit',
    component: Tags,
    props: {
      type: 'edit'
    }
  }
]
</script>
